import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { classNameWithModifiers as withMods } from 'helpers/class-name';
import InternalErrorComponent from 'components/InternalError';

import ColumnLayout from './ColumnLayoutContainer';
import Column from './ColumnContainer';
import { PageLayoutContext } from './Contexts';
import { FooterFormPresenceProvider } from './FooterFormPresenceContext';

export const PAGE_LAYOUT_VARIANT = {
  NARROW: 'narrow',
  WIDE: 'wide',
};

const PageLayout = props => {
  const [headerTop, setHeaderTop] = useState(0);

  const { children, hasInternalError, isAuthenticated, layoutInfo, shouldDisplay, sidenavCollapsed } = props;
  if (!shouldDisplay) return null;

  const wrappedChildren = layoutInfo.hasMultipleColumns ? (
    children
  ) : (
    <ColumnLayout>
      <Column>{children}</Column>
    </ColumnLayout>
  );

  return (
    <PageLayoutContext.Provider value={{ layoutInfo, headerTop, setHeaderTop }}>
      <FooterFormPresenceProvider>
        <main
          className={withMods('app', {
            sidenavCollapsed,
            noSideNav: !isAuthenticated,
          })}>
          {hasInternalError ? <InternalErrorComponent /> : wrappedChildren}
        </main>
      </FooterFormPresenceProvider>
    </PageLayoutContext.Provider>
  );
};

PageLayout.propTypes = {
  children: PropTypes.node,
  hasInternalError: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  layoutInfo: PropTypes.shape({
    hasMultipleColumns: PropTypes.bool,
    hideVenueSelector: PropTypes.bool,
    isFixedPage: PropTypes.bool,
    pageLayout: PropTypes.oneOf([PAGE_LAYOUT_VARIANT.WIDE, PAGE_LAYOUT_VARIANT.NARROW, 'public']),
  }),
  shouldDisplay: PropTypes.bool,
  sidenavCollapsed: PropTypes.bool,
};

export default PageLayout;
